module.exports = __webpack_public_path__ + "static/Shailesh-02b3a74a56d74ff241c927a9b6b4a98a.jpg";